import * as THREE from 'three';
import { mat } from '../world/palette.js';
import type { CharacterAgent } from './characters.js';
import { patrolPath } from './characters-paths.js';

export type StaffRole = 'waiter' | 'kitchen' | 'grill' | 'bar' | 'cashier' | 'client';

const ROLE_COLORS: Record<StaffRole, number> = {
  waiter: 0x2f4f6f,
  kitchen: 0xf5f5f5,
  grill: 0x3d3d3d,
  bar: 0x5c2e2e,
  cashier: 0x4a3728,
  client: 0xc17a4a,
};

function buildStylizedHuman(role: StaffRole, tint: number): THREE.Group {
  const g = new THREE.Group();
  const bodyMat = mat(tint, { roughness: 0.55 });
  const skin = mat(0xffd7b5, { roughness: 0.65 });
  const torso = new THREE.Mesh(new THREE.CapsuleGeometry(0.26, 0.62, 6, 12), bodyMat);
  torso.position.y = 1.02;
  torso.castShadow = true;
  const head = new THREE.Mesh(new THREE.SphereGeometry(0.22, 16, 14), skin);
  head.position.y = 1.52;
  head.castShadow = true;
  const legL = new THREE.Mesh(new THREE.CylinderGeometry(0.09, 0.11, 0.42, 8), mat(0x2a2a2a));
  legL.position.set(-0.12, 0.22, 0);
  legL.userData.leg = 'L';
  const legR = legL.clone();
  legR.position.x = 0.12;
  legR.userData.leg = 'R';
  g.add(torso, head, legL, legR);
  g.userData.walkPhase = Math.random() * Math.PI * 2;
  if (role === 'waiter') {
    const apron = new THREE.Mesh(new THREE.BoxGeometry(0.48, 0.5, 0.1), mat(0xffffff));
    apron.position.set(0, 0.92, 0.16);
    g.add(apron);
  }
  if (role === 'grill') {
    const hat = new THREE.Mesh(new THREE.BoxGeometry(0.4, 0.12, 0.4), mat(0x111111));
    hat.position.y = 1.68;
    g.add(hat);
  }
  return g;
}

export function spawnStylizedCast(root: THREE.Group): CharacterAgent[] {
  const roles: StaffRole[] = ['kitchen', 'grill', 'bar', 'cashier'];
  const agents: CharacterAgent[] = [];
  roles.forEach((role, i) => {
    const mesh = buildStylizedHuman(role, ROLE_COLORS[role]);
    mesh.position.set(-12 + i * 2.2, 0, -6);
    root.add(mesh);
    agents.push({
      mesh,
      role: 'staff',
      path: patrolPath('staff', i),
      pathIndex: 0,
      speed: 0.85 + i * 0.05,
      phase: i,
    });
  });
  return agents;
}
